<template>
<div class="container-fluid" >

 <div class="card border-success">

  <div class="card-header text-white bg-primary">
    <h4><i style="color:yellow" class="far fa-check-circle mr-2" aria-hidden="true"></i>CHECK LIST STOCK FORNITORE </h4>
  </div> 

 <div class="card-body"> 
  
 <div class="row">


  <div v-if="type=='A'" class="col"> 

  <div class="" >
  <div class="">
    <i style="color:blue" class="fas fa-stream mr-2" aria-hidden="true"></i>
    <strong>PARAMETRI DI RICERCA</strong>
    <hr>
  </div>
  <div class="card-body text-dark">


  <form name="movementSearch" v-on:submit.prevent="submit()">

    
      
        <div class="row">
        
          <div class="form-group col-md-4">         
          <supplier-select v-bind:props="supplier" @update="setSupplierId"></supplier-select>             
        </div>

        <div class="form-group col-md-4"> 
          <supplier-brand-list :key="refresh"  v-bind:props="brand" @update="setBrandId"></supplier-brand-list>
        </div>
       
        <div class="form-group col-md-2">   
          <season-select v-bind:required="true" v-bind:isActive="items.length==0" v-bind:type="true"  @update="setSeasonId"></season-select>
        </div> 

        <div class="form-group col-md-2">
          <year-select  v-bind:props="season_year" @update="setYear"></year-select>
        </div>

       </div>  
        
        
       <div class="row">
          <div class="form-group col-md-4">   
            <department-select  v-bind:required="true" v-bind:isActive="items.length==0" v-bind:type="true" @update="setDepartmentId"></department-select>
          </div>


        <div class="form-group col-md-4">   
          <category-select v-bind:required="true" v-bind:isActive="items.length==0" @update="setCategoryId"></category-select>
        </div>

        </div>  

      <div class="mt-1 mb-3 ml-4">  
      <stock-filter @update="setStockFilter"></stock-filter>
      </div>
    

      <alert-box class="mt-2 mb-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
    
           
   <button type="submit"  class="btn btn-primary float-right">
    <i class="far fa-play-circle mr-2"></i>
    ESEGUI
      <span v-if="spinner" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
     </button>           

     <!--
    <button @click="items=[],row_total=[]" type="button"   class="btn btn-secondary ml-3">
       <i style="color:yellow" class="fas fa-redo-alt mr-2"></i>
      
        RESET
    </button>   
  -->


  </form>

 </div>
</div>

</div>














  <div v-else class="col">

   
    <button @click="items=[],row_total=[],type='A'" type="button"   class="btn btn-secondary ml-3 mb-1">
       <i style="color:yellow" class="fas fa-reply mr-2"></i>
      
         RITORNA A PARAMETRI RICERCA
    </button>   
    
  <div class="table-wrapper-scroll-y my-custom-scrollbar">

  <table class="table table-hover master">
    <thead >
      <tr class="table-primary">
        
        <th>#</th>
        <th></th>
        <th scope="col">PRODOTTO ID</th>
        <th scope="col">BRAND</th>
        <th scope="col">CODICE</th>
        <th scope="col">CATEGORIA</th>
        <th scope="col">STAGIONE</th>
        <th scope="col">ANNO</th>
        <th scope="col">REPARTO</th>
        
   
      </tr>
    </thead>
    <tbody>
      <tr @click="openDetail(index)"  class="pointer" v-for="(item, index) in items" :key="index">

        <td>{{index+1}}</td>               
        <td>
          <span :class="{dotRed:item.sale_qty == 0}"></span>
        </td>  
        <td>{{item.productId}}</td>        
        <td>{{item.brand}}</td>        
        <td> {{item.sku}}
          
          <div v-if="isOpen[index]==true">
          <component :key = "componentKey" v-bind:spinner="spinner1" v-bind:is="component" v-bind:cols="cols" v-bind:rows="rows"></component>          
          <span v-if="spinner1" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> 
          </div>
        </td>   
        <td >{{item.category}}</td>   
        <td >{{item.season}} </td>        
        <td>{{item.season_year}} </td>
        <td>{{item.department}} </td>
        
       
      </tr> 
    </tbody>

    <tfoot>
    
    </tfoot>    
  </table>

</div>

  </div>  


    </div>




 </div>

 </div>
  
</div>


</template>
<script>
import api               from "@/api";
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';

import supplierSelect    from '@/components/common/SupplierSelect_1.vue'
import seasonSelect      from '@/components/common/SeasonSelect.vue'

import departmentSelect  from '@/components/common/DepartmentSelect.vue'
import categorySelect    from '@/components/common/CategoryGroupingSelect.vue'
import productStock      from '@/components/common/ProductStock.vue'
import stockFilter       from '@/components/common/StockFilter.vue'

import yearSelect        from '@/components/common/YearSelect_1.vue'
import supplierBrandList from '@/components/common/SupplierBrandSelect_1.vue'
import fmt               from '@/components/mixins/fmt'

export default {
  mixins     : [fmt],
  components: {alertBox,supplierSelect,seasonSelect,yearSelect,departmentSelect,categorySelect,productStock,stockFilter,yearSelect,supplierBrandList},
  data() {
    return {


      type            : 'A',
      season_year     : 
      {
        year          : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : true

      },

      supplier        : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true

      },
      brand           :
      {
        supplierId    : 0,
        Id            : '%',
        required      : false,
        allBrands     : true

      },  

      isOpen          : [], 
      component       : '', 
      
      seasonId        : 0,
      departmentId    : 0,
      categoryId      : 0,
    
      year            : 0,
      
      

      spinner         : false,
      spinner1        : false,
      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
    
      items           : [],
      cols            : [],
      rows            : [],
      componentKey    : 0,
      stock           : 1,
      refresh         : 100
      
      
      
    };
  },

  computed :{
    ...mapGetters(['company']),
   
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() {
    
   
  },
  methods: {
    setSupplierId(supplierId)
    {        
      this.supplier.Id = supplierId
      
      this.brand.supplierId = supplierId
      this.refresh++
      
    }, 
    setBrandId(brandId)
    {
      
      this.brand.Id = brandId
    },
    setYear(year)
    {
      this.season_year.year = year
     
    },
    setStockFilter(stock)
    {
      this.stock = stock
    },

    async openDetail(index)
    {

      this.isOpen=[]
      this.spinner1 = true
      this.isOpen[index]=true

      const sp = {'sp' : 'spStoreProductStockDetail'}      
      const data  = {
        'productId':this.items[index]['productId']
      }
      
      const json  = Object.assign(data, sp)
      

      await api.post(json).then(res => {
        
          if(res.status==200)
            {

              const arr = res.data.recordsets[0]

              arr.forEach(item => 
              {
              if(item.tipo == 0)
              {
                item.tipo = 'AC'
              }
              else if(item.tipo == 1)
              {
                item.tipo = 'VB'
              }
              else
              {
                item.tipo = 'ST'
              }
          
            })

            this.component = ''
            
            
            this.cols = []
            this.rows = []
            
            this.cols.push('store')
            this.cols.push('color')
            this.cols.push('tipo')
            this.cols.push('data')
            this.cols.push('total')
   
            const cols = arr[0]['sizes'].split('|')
            cols.forEach(item=>{
              this.cols.push(item)
            })
            this.rows = arr
            this.component = 'productStock'
            this.componentKey++
                         
              
              if(arr.length==0)
              {
               
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = 'DATI INESISTENTI.'
                this.msg.type  = 1
              }

            }
            else if (res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
        
          else
          {

            

            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
                        

          }
      }).catch(err=>{
        
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1
        

      }).finally(() => {
          this.spinner1 = false
        });
      
      
    },

    setCategoryId(categoryId)
    {
      

      this.categoryId = categoryId
    },  
   
    setDepartmentId(departmentId)
    {
      this.departmentId = departmentId
    },
    setSeasonId(seasonId)
    {   
        
        this.seasonId = seasonId
    },  
   
    
    submit() 
    {
      
      
      this.getData()
    },  
    
        
    async getData() {
      
      this.isOpen = []
      this.cols = []
      this.rows = []
      
      this.items = []
      
      
     
     
      this.msg.title = ''
      const sp = {'sp' : 'spProductListStockCheck'}
      const data  = {
        'companyId':this.company.Id,'supplierId' :this.supplier.Id,'seasonId':this.seasonId,
        'departmentId':this.departmentId,'categoryId':this.categoryId,'stock':this.stock,'season_year':this.season_year.year,'brand':this.brand.Id
      }
      
      const json  = Object.assign(data, sp)
      
      this.spinner = true
      
      

      await api.post(json).then(res => {
       
          if(res.status==200)
            {
              
              this.items = res.data.recordsets[0]

      

              
                      
              if(this.items.length==0)
              {
       
                this.msg.title = 'ATTENZIONE'
                this.msg.body  = 'DATI INESISTENTI.'
                this.msg.type  = 1
                return
              }
              this.type = 'B'
              

            }
            else if (res.status==500)
            {
       
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
       
          else
          {

       
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
                        

          }
      }).catch(err=>{
        
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1
        

      }).finally(() => {
          this.spinner = false
        });
      

    }
  }
};
</script>
<style scoped>


.my-custom-scrollbar {
position: relative;
height: 700px;
overflow: auto;
}
.pointer:hover
{
  _background-color: white;
  
  cursor: pointer;
}

.detail tr:nth-child(1) th  {
    background   : yellow;
}
.master tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 20px;
    background   : #FFFFE0;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;

 }

.table-wrapper-scroll-y {
display: block;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}



h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.form-check-label{
  cursor:pointer
}
.dotRed
{
  height: 15px;
  width: 15px;
  
  border-radius: 50%;
  display: inline-block;
  background-color: red;
}
</style>